import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.local';
@Injectable({ providedIn: 'root' })
export class NotifyService {
    private subject = new Subject<any>();
    constructor(private router: Router, private toastr: ToastrService,private http: HttpClient) {}
   
    sendMessage(item: any) {
        this.subject.next(item);
    }

    clearMessages() {
        this.subject.next(null);
    }

    onMessage(): Observable<any> {
        return this.subject.asObservable();
    }
    GetUserNotifications(userId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetUserNotifications?userId=${userId}`)
    }
    ClearNotifications(data: any) {
        return this.http.post(`${environment.BASE_API_URL}common/ClearNotifications`, data);
    }
}